// Column definition interface
import React from 'react';

export interface ColumnDefinition {
  field: any;
  label: string;
  filterable: boolean;
  filter_type: string;
  order: number;
  show: boolean;
  systemHidden?: boolean;
  type: string;
  sortable: boolean;
  format?: any;
  group?: string;
  groupStart?: boolean;
  render?: (value: any, row: any) => React.ReactNode;
}

export interface PivotConfig {
  rows: string[];
  subtotalBy?: string;
}

// Sort model type
export interface SortModel {
  field: string;
  order: 'asc' | 'desc';
}

// FetchData parameters
export interface FetchParams {
  offset: number;
  limit: number;
  sortModel: SortModel[];
  filters: KeyValuePair[];
}

// FetchData response
export interface FetchResponse {
  data: any[];
  filter_values: any;
  total_count: number;
  columns?: any;
  filters?: any;
  pivot_columns?: ColumnDefinition[];
  pivot?: PivotConfig;
}

export type KeyValuePair = {
  key: string;
  value: string;
};

export interface QueryError {
  details: string;
  error: string;
}

export enum GridSlicerTypes {
  // eslint-disable-next-line no-unused-vars
  SELECT = 'select',
  // eslint-disable-next-line no-unused-vars
  MULTI_SELECT = 'multiselect',
  // eslint-disable-next-line no-unused-vars
  TEXT = 'text',
  // eslint-disable-next-line no-unused-vars
  DATE_PICKER = 'date',
  // eslint-disable-next-line no-unused-vars
  CONDITIONAL = 'conditional',
}
